import { Fragment } from 'react';

import PropTypes from 'prop-types';
import { getFormattedNumber, getFormattedNumberWithPercent } from 'utils/clickme';
import { NON_BREAKING_SPACE } from 'utils/constants/common';

import Tip, { TipPlacement } from 'bloko/blocks/drop/Tip';
import HoverTip from 'bloko/blocks/drop/Tip/HoverTip';

import useTrls from 'hooks/translation/useTrls';

import Label from 'components/Label';

import 'components/Admin/Invoices/InvoicesTable/Invoice/Invoice.less';

const Amounts = ({ amount, promoBonus }) => {
    const trl = useTrls();

    return (
        <Fragment>
            <p data-qa="invoice-amount">
                {getFormattedNumber(amount)}
                {NON_BREAKING_SPACE}
            </p>
            {promoBonus > 0 && (
                <HoverTip
                    placement={TipPlacement.Top}
                    render={() => <div>{trl('admin.Invoices.InvoicesTable.Invoice.bonus')}</div>}
                    host={document.body}
                    DropElement={Tip}
                >
                    <p>
                        <Label type="secondary" dataQa="invoice-bonus">
                            {getFormattedNumberWithPercent(promoBonus)}
                        </Label>
                    </p>
                </HoverTip>
            )}
        </Fragment>
    );
};

Amounts.propTypes = {
    amount: PropTypes.number,
    promoBonus: PropTypes.number,
};

export default Amounts;
